"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMediaMetadata = instanceOfMediaMetadata;
exports.MediaMetadataFromJSON = MediaMetadataFromJSON;
exports.MediaMetadataFromJSONTyped = MediaMetadataFromJSONTyped;
exports.MediaMetadataToJSON = MediaMetadataToJSON;
exports.MediaMetadataToJSONTyped = MediaMetadataToJSONTyped;
/**
 * Check if a given object implements the MediaMetadata interface.
 */
function instanceOfMediaMetadata(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    if (!('fileUrl' in value) || value['fileUrl'] === undefined)
        return false;
    if (!('fileType' in value) || value['fileType'] === undefined)
        return false;
    return true;
}
function MediaMetadataFromJSON(json) {
    return MediaMetadataFromJSONTyped(json, false);
}
function MediaMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'fileName': json['fileName'],
        'fileUrl': json['fileUrl'],
        'fileType': json['fileType'],
        'altText': json['altText'] == null ? undefined : json['altText'],
    };
}
function MediaMetadataToJSON(json) {
    return MediaMetadataToJSONTyped(json, false);
}
function MediaMetadataToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fileName': value['fileName'],
        'fileUrl': value['fileUrl'],
        'fileType': value['fileType'],
        'altText': value['altText'],
    };
}
